import "./chunk--chunk-Z7A6LSGX.vbt.js";

// src/js/components/Tabs.js
var Tabs = class {
  constructor(el, sel) {
    this.el = el;
    this.interactionType = el.getAttribute(sel);
    this.toggles = el.querySelectorAll("[data-tab-toggle]");
    this.contents = el.querySelectorAll("[data-tab-content]");
    this.close = el.querySelectorAll("[data-tabs-close]");
    let initialActiveTab = window.location.href.split("?tab=")[1];
    if (initialActiveTab) {
      for (const toggle of this.toggles) {
        if (toggle.getAttribute("data-tab-toggle") === initialActiveTab) {
          this.updateContent(toggle);
          break;
        }
      }
    }
  }
  init() {
    this.toggles.forEach((toggle) => {
      toggle.addEventListener(this.interactionType, () => {
        this.updateContent(toggle);
      });
    });
    if (this.close) {
      this.close.forEach((el) => el.addEventListener("click", () => {
        const activeToggle = this.el.querySelector("[data-tab-toggle].active");
        activeToggle.classList.remove("active");
        activeToggle.setAttribute("aria-selected", "false");
        this.el.querySelector("[data-tab-content].active").classList.remove("active");
      }));
    }
  }
  updateContent(toggle) {
    const tabName = toggle.getAttribute("data-tab-toggle");
    const activeToggle = this.el.querySelector("[data-tab-toggle].active");
    if (activeToggle) {
      activeToggle.classList.remove("active");
      activeToggle.setAttribute("aria-selected", "false");
    }
    toggle.classList.add("active");
    toggle.setAttribute("aria-selected", "true");
    if (tabName !== "self") {
      const activeTab = this.el.querySelector(`[data-tab-content].active`);
      if (activeTab) {
        activeTab.classList.remove("active");
        activeTab.setAttribute("aria-selected", "false");
      }
      const newActiveTab = this.el.querySelector(`[data-tab-content='${tabName}']`);
      newActiveTab.classList.add("active");
      newActiveTab.setAttribute("aria-selected", "true");
    }
  }
};
var Tabs_default = Tabs;
export {
  Tabs_default as default
};
